import axios from 'axios'
import { action, makeAutoObservable, runInAction } from 'mobx'
import { posTheme } from '../constants/pos.theme'
import { amexTheme } from '../constants/amex.theme'
import { bmwTheme } from '../constants/bmw.theme'
import { checkoutTheme } from '../constants/checkout.theme'
import { ikanoTheme } from '../constants/ikano.theme'
import { miniTheme } from '../constants/mini.theme'
import { signicatTheme } from '../constants/signicat.theme'

interface StepInterface {
  order: number
  completed: boolean
}

export class AppStateStore {
  rootStore
  authorization = false
  initalAuthCheck = false
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  theme: any = posTheme
  pageWidth: number = 0
  pageHeight: number = 0

  constructor(rootStore) {
    makeAutoObservable(this)

    this.rootStore = rootStore
  }

  @action.bound setAuthorization(auth: boolean): void {
    this.authorization = auth
  }

  @action.bound changeTheme(themeId: string): void {
    if (themeId === 'signicat') {
      this.setTheme(signicatTheme)
    }

    if (themeId === 'bmw') {
      this.setTheme(bmwTheme)
    }

    if (themeId === 'mini') {
      this.setTheme(miniTheme)
    }

    if (themeId === 'amex') {
      this.setTheme(amexTheme)
    }

    if (themeId === 'ikano') {
      this.setTheme(ikanoTheme)
    }

    if (themeId === 'pos') {
      this.setTheme(posTheme)
    }

    if (themeId === 'checkout') {
      this.setTheme(checkoutTheme)
    }
  }

  @action.bound setTheme(theme): void {
    this.theme = theme
  }

  @action.bound setPageWidth(width: number): void {
    this.pageWidth = width
  }

  @action.bound setPageHeight(height: number): void {
    this.pageHeight = height
  }

  @action.bound skipAuth(): void {
    this.initalAuthCheck = true
    this.authorization = true
    // this.rootStore.Router.setLocation(window.location.pathname.substring(1))
  }

  // to be rewritten
  @action
  async checkLogin() {
    try {
      const res = await axios(
        'https://merchant-poc-2577551f9ce2.herokuapp.com/auth/check',
        {
          method: 'GET',
          withCredentials: true,
        }
      )

      console.log(res)

      runInAction(() => {
        this.initalAuthCheck = true
        this.authorization = true
        // this.rootStore.Router.setLocation(window.location.pathname.substring(1))
      })
    } catch (e) {
      runInAction(() => {
        this.initalAuthCheck = true
        this.authorization = true // set to "true" to skip authorization for local development
        // this.rootStore.Router.setLocation(window.location.pathname.substring(1))
      })
      console.log(e)
    }
  }
}
